import * as React from 'react'
import { SwishForm , PaymentMethodKeys} from '../Types/PaymentFormTypes';
import { Icon } from '../Icons/Icon';
import { Card } from './Card';
import FadeIn from '../Animations/FadeIn';
import './PaymentMethod.css'
import { Button } from './Button';
import { Modal } from './Modal';
import { PrivacyPolicy } from '../Pages/PrivacyPolicy';
import { TermsOfService } from '../Pages/TermsOfService';
import { stepColors } from './paymentColors';
import { Turnstile } from '@marsidev/react-turnstile';
interface IPaymentMethodProps{
    onConfirmation:(method:PaymentMethodKeys,policyAccepted:boolean,captchaToken:string | null) => Promise<void>;
    swishForm:SwishForm;
    requiresCaptcha?: boolean;
}
const paymentMethods = [
  {
    id: "swish" as PaymentMethodKeys,
    name: "Swish",
    description: "Betala direkt med Swish",
    icon: <Icon.SwishIcon/>,
    recommended: true,
  },
  {
    id:'stripe' as PaymentMethodKeys,
    name:'Stripe',
    description:"Kortbetalning eller Klarna (direkt, senare eller delbetalning)",
    icon:<Icon.StripeIcon/>,
    recommended:true
  }
];
export const PaymentMethod = ({onConfirmation,swishForm,requiresCaptcha = false}:IPaymentMethodProps) => {
    const [selectedMethod, setSelectedMethod] = React.useState<PaymentMethodKeys | null>(
    null
  );
    const [showModal,setShowModal] = React.useState<boolean>(false);
    const [acceptPolicys,setAcceptPolicys] = React.useState<boolean>(false);
    const [captchaToken, setCaptchaToken] = React.useState<string | null>(null);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const isE2ETesting = process.env.REACT_APP_E2E_TESTING === '1';
    const handleConfirm = async () => {
    if (!selectedMethod || isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      await onConfirmation(selectedMethod,acceptPolicys,captchaToken);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <FadeIn>
    <div className="paymentmethod-stack">
      <div>
        <h3 className="paymentmethod-text">Välj betalningsmetod</h3>
        <div className="paymentmethod-card-stack">
          {paymentMethods.map((method) => (
            <Card
              key={method.id}
              className={`paymentmethod-card-container ${selectedMethod === method.id ? 'selected-card':'not-selected-card'}`
            }
              onClick={() => setSelectedMethod(method.id)}
            >
              <div className="paymentmethod-card-item-container">
                <div
                  className={`paymentmethod-card-item-icon ${selectedMethod === method.id ? 'selected-icon-background' : 'not-selected-icon-background'}`
                }
                >
                   {method.icon}
                </div>
                <div className="paymentmethod-card-item-text-container">
                  <div className="paymentmethod-card-item-flex-container">
                    <h4 className="paymentmethod-span-fontw">{method.name}</h4>
                    {method.recommended && (
                      <span className="paymentmethod-span-text">
                        Rekommenderad
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-muted-foreground">
                    {method.description}
                  </p>
                </div>
                <div
                  className={`paymentmethod-swish-container ${selectedMethod === method.id ? 'paymentmethod-swish-container-selected':'swish-not-active-border'}`
                }
                >
                  {selectedMethod === method.id && (
                    <Icon.CheckMarkCircle  />
                  )}
                  {selectedMethod !== method.id && (
                    <Icon.EmptyCircle  fill={stepColors.active}/>
                  )}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
      <>
          <div className='accept-policy-container'>
            
             <div className='accept-policy-items-container'>
              <div style={{cursor:'pointer'}} onClick={() => setAcceptPolicys(prev => !prev)}> 
                {acceptPolicys ? <Icon.FilledCheckmarkCircle width={15} height={15} fill={stepColors.success}/> :<Icon.EmptyCircle width={15} height={15} fill={stepColors.active}/>}
                </div>
               <p style={{padding:0,margin:'0px 5px',fontWeight:400}}>Jag godkänner</p> 
               <p onClick={() => setShowModal(true)} style={{padding:0,margin:0,textDecoration:'underline',fontStyle:'italic',color:'blue',fontWeight:400,cursor:'pointer'}}> användarvillkoren och Integritetspolicyn</p>
               </div>
            
          </div>
      </>
      {requiresCaptcha && (
        <div className="contact-turnstile-block" style={{ marginTop: 16 }}>
          <label>Bekräfta att du inte är en robot *</label>
          {isE2ETesting ? (
            <button type="button" onClick={() => setCaptchaToken('e2e-test-token')}>E2E captcha</button>
          ) : (
            <Turnstile
              siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY!}
              onSuccess={(token) => setCaptchaToken(token)}
              onExpire={() => setCaptchaToken(null)}
              options={{ theme: 'light' }}
            />
          )}
        </div>
      )}
      <Button
        onClick={handleConfirm}
        style={{cursor:'pointer'}}
        className='submit-button'
        text={'Bekräfta betalning'}
        disabled={!selectedMethod || (requiresCaptcha && !captchaToken) || isSubmitting}
      />   
    </div>
    {showModal && 
        <FadeIn>
          <Modal className='' style={{maxWidth:600}} onClose={() => setShowModal(false)}>
      <TermsOfService showContact={false}/>
      <PrivacyPolicy showContact={false}/>
    </Modal>
        </FadeIn>
    }
    
    </FadeIn>
  );
}
